<template>
    <v-container fluid class="white elevation-4 pt-0 pb-0">
        <main-app-bar :title="$router.currentRoute.meta.title"></main-app-bar>
        <v-row class="d-block grey lighten-4">
            <v-container>
                <v-row>
                    <v-col cols="auto" class="py-0">
                        <v-btn color="black lighten-2" text class="btn-filter" :disabled='initialLoading' @click="filterOpened = !filterOpened">
                            Filters
                            <v-icon style="fill: #000;" right>$filter</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
            <v-expand-transition>
                <v-card v-show="filterOpened" elevation="0" class="px-5 transparent" height="auto" style=" width: 100%;" :disabled="getPoliciesLoading">
                    <v-row class="align-start">
                        <v-col cols="6">
                            <v-autocomplete
                                multiple
                                clearable
                                v-model="filterOptions.DocumentTypeIds"
                                :items="metaData.documentTypes"
                                :search-input.sync="searchInputAutocomplete[searchInputConst.types]"
                                @change="changeOption(searchInputConst.types)"
                                item-text="value"
                                item-value="id"
                                placeholder="Select category"
                                label="Category"
                                dense
                                hide-details
                                outlined
                                lighten-1
                            >
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="selection-text-style">{{item.value}}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                    >(+{{ filterOptions.DocumentTypeIds.length - 1 }} others)</span>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="reviewDateAlias"
                                transition="scale-transition"
                                offset-y
                                max-width="290"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="reviewDateAlias && reviewDateAlias.length ? Date.formatDate(reviewDateAlias) : []"
                                        placeholder="Select Date Range"
                                        label="Next review"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        outlined
                                        dense
                                        v-on="on"
                                        clearable
                                        @click:clear='reviewDateAlias = [];filterOptions.NextReviewFrom = "";filterOptions.NextReviewTo = "";'
                                    />
                                </template>
                                <v-date-picker v-model="reviewDateAlias" range>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="reviewDateAliasChange(reviewDateAlias)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row class="align-start">
                        <v-col cols="6" class='d-flex'>
                            <v-checkbox label="Archived" v-model="filterOptions.IsArchived" :value="false" class="ma-0"/>
                        </v-col>
                    </v-row>
                </v-card>
            </v-expand-transition>
        </v-row>
        <v-row class="d-block lighten-4 align-center">
            <v-data-table
                :loading="getPoliciesLoading"
                :headers="headers"
                :items="policyItems"
                :options.sync="options"
                :items-per-page="options.itemsPerPage"
                :server-items-length="metaData.totalElements"
                :footer-props="{
                        'show-current-page': true,
                        'show-first-last-page': true,
                        'items-per-page-options': [10,20,50]
                    }"
            >
                <template v-slot:body="{ items }">
                    <template v-if="items.length">
                        <tr :key="`${item.id}-${index}`" v-for="(item, index) of items" style='cursor: pointer;' @click='openCurrentPolicy(item)'>
                            <template v-if="item.id">
                                <td>
                                    {{ item.name.toUpperCase() }}
                                </td>
                                <td>
                                    {{ item.documentTypeName }}
                                </td>
                                <td>
                                    {{ Date.formatDate([item.reviewedOn]) }}
                                </td>
                                <td>
                                    <div class='d-flex align-center'>
                                        {{ Date.formatDate([item.nextReview]) }}
                                        <v-progress-circular :value="circleValue(item.reviewedOn, item.nextReview)" :color="circleColor(item.nextReview)" size="20" width="3" class='ml-1'/>
                                    </div>
                                </td>
                            </template>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td :colspan="headers.length">
                                <div class="text-center grey--text py-4">No data available</div>
                            </td>
                        </tr>
                    </template>
                </template>
            </v-data-table>
        </v-row>
        <v-dialog v-model="policyDialog" width="1024" @click:outside="closePolicyDialog">
            <v-card>
                <v-card-title class="py-3 body-1 grey lighten-3 d-flex justify-space-between font-weight-regular">
                    {{selectedPolicy && selectedPolicy.originalName ? selectedPolicy.originalName : '...'}}
                    <v-btn icon @click="closePolicyDialog" class="ml-auto">
                        <v-icon>$close</v-icon>
                    </v-btn>
                </v-card-title>
                <div style='min-height: 208px;position: relative;'>
                    <v-progress-linear v-if='selectedPolicyLoading' absolute height="4" indeterminate color="primary"/>
                    <v-card-text v-if='selectedPolicy && !selectedPolicyLoading' class="pa-5">
                        <SimpleFilePreview :fileData="selectedPolicy"/>
                    </v-card-text>
                    <v-card-text v-if='selectedPolicy && selectedPolicy.history && !selectedPolicyLoading' class="pt-5 pb-0 px-0">
                        <div class="d-flex justify-center py-2 grey lighten-4"><strong>HISTORY</strong></div>
                        <v-simple-table dense class="history-table">
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th class="py-2" style="width: 30%">Reviewed On</th>
                                    <th class="py-2" style="width: 30%">Reviewed By</th>
                                    <th class="py-2" style="width: 40%">Next Review</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(record, i) in selectedPolicy.history" :key="i">
                                    <td class="py-2">
                                        {{ Date.getFormatDateStr(record.reviewedOn) }}
                                    </td>
                                    <td class="py-2">
                                        {{ record.reviewedBy }}
                                    </td>
                                    <td class="py-2">
                                        {{ Date.getFormatDateStr(record.nextReview) }}
                                    </td>
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </div>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true" class="text-center justify-center">
            <div class="text-center flex-grow-1">{{ snackbarText }}</div>
        </v-snackbar>
    </v-container>
</template>

<script>
    import MainAppBar from '@/components/MainAppBar'
    import SimpleFilePreview from '@/views/accounting/SimpleFilePreview.vue'
    import selectInputAutocomplete from '../../constatns/selectInputAutocomplete'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        components: {
            SimpleFilePreview,
            MainAppBar
        },
        data () {
            return {
                metaData: {},
                menu: false,
                snackbar: false,
                snackbarText: '',
                snackbarColor: 'error',
                initialLoading: true,
                getPoliciesLoading: false,
                filterOpened: false,
                reviewDateAlias: [],
                filterOptions: {
                    DocumentTypeIds: null,
                    IsArchived: false,
                    NextReviewFrom: '',
                    NextReviewTo: ''
                },
                policyDialog: false,
                selectedPolicyLoading: false,
                selectedPolicy: null,
                searchInputConst: selectInputAutocomplete,
                searchInputAutocomplete: {
                    [selectInputAutocomplete.types]: null
                },
                options: {
                    itemsPerPage: 10,
                    page: 1,
                    sortBy: ['reviewedOn'],
                    sortDesc: [true],
                    mustSort: false,
                    multiSort: false
                },
                policyItems: []
            }
        },
        computed: {
            ...mapGetters(['getDocumentTypes', 'getUserActiveGroup', 'getUserActiveClinic']),
            headers () {
                const headers = [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: true,
                        value: 'name'
                    },
                    {
                        text: 'Category',
                        align: 'left',
                        sortable: true,
                        value: 'documentTypeName'
                    },
                    {
                        text: 'Reviewed On',
                        align: 'left',
                        sortable: true,
                        value: 'reviewedOn'
                    },
                    {
                        text: 'Next Review',
                        align: 'left',
                        sortable: true,
                        value: 'nextReview'
                    }
                ]
                return headers
            },
            groupId () {
                return this.getUserActiveGroup
            },
            clinicId () {
                return this.getUserActiveClinic
            }
        },
        watch: {
            options: {
                handler (newValue, oldValue) {
                    if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                        this.getPolicies()
                    }
                },
                deep: true
            },
            filterOptions: {
                handler () {
                    this.options.page = 1
                    this.getPolicies()
                },
                deep: true
            },
            groupId () {
                this.options.page = 1
                this.getPolicies()
            },
            clinicId () {
                this.options.page = 1
                this.getPolicies()
            }
        },
        methods: {
            ...mapActions(['fetchPolicies', 'createPolicy', 'uploadDocuments', 'updatePolicy', 'fetchSinglePolicy']),
            changeOption (typeSearch) {
                this.searchInputAutocomplete[typeSearch] = ''
            },
            reviewDateAliasChange (date) {
                this.$refs.menu.save(date)
                if (this.reviewDateAlias.length === 2) {
                    this.reviewDateAlias = this.reviewDateAlias.sort((a, b) => new Date(a) - new Date(b))
                    this.filterOptions.NextReviewFrom = this.reviewDateAlias[0]
                    this.filterOptions.NextReviewTo = this.reviewDateAlias[1]
                }
            },
            circleValue (reviewedOn, nextReview) {
                const localReviewedOn = new Date(reviewedOn)
                const localNextReview = new Date(nextReview)
                const today = new Date()

                const periodDifferenceInTime = localNextReview - localReviewedOn
                const todayDifferenceInTime = localNextReview - today

                let percentageRemaining = (todayDifferenceInTime / periodDifferenceInTime) * 100
                percentageRemaining = Math.max(0, Math.min(100, percentageRemaining))

                return 100 - percentageRemaining.toFixed(2)
            },
            circleColor (nextReview) {
                const localNextReview = new Date(nextReview)
                const today = new Date()

                if (today > localNextReview) {
                    return 'red'
                } else if (today < localNextReview) {
                    return 'primary'
                }
                return 'primary'
            },
            openPolicyDialog () {
                this.policyDialog = true
            },
            closePolicyDialog () {
                this.policyDialog = false
                this.selectedPolicy = null
            },
            async openCurrentPolicy (policyData) {
                try {
                    this.selectedPolicyLoading = true
                    this.openPolicyDialog()
                    const newPolicyData = await this.fetchSinglePolicy(policyData.id)
                    this.selectedPolicy = {
                        id: newPolicyData.data.id,
                        originalName: newPolicyData.data.attachment.originalName,
                        history: newPolicyData.data.history,
                        link: newPolicyData.data.attachment.link,
                        extension: newPolicyData.data.attachment.extension
                    }
                    this.selectedPolicyLoading = false
                } catch (e) {
                    this.selectedPolicyLoading = false
                }
            },
            policiesParams () {
                const localFilterOptions = {}
                this.filterOptions.DocumentTypeIds && (localFilterOptions.DocumentTypeIds = this.filterOptions.DocumentTypeIds)
                localFilterOptions.IsArchived = this.filterOptions.IsArchived
                if (this.filterOptions.NextReviewFrom && this.filterOptions.NextReviewTo) {
                    localFilterOptions.NextReviewFrom = this.filterOptions.NextReviewFrom
                    localFilterOptions.NextReviewTo = this.filterOptions.NextReviewTo
                }
                const queryData = {
                    GroupId: this.groupId,
                    ClinicIds: [this.clinicId],
                    PageSize: this.options.itemsPerPage,
                    PageNumber: this.options.page,
                    sortField: this.options.sortBy[0] || 'id',
                    sortOrder: this.options.sortDesc[0] ? 'DESC' : 'ASC',
                    ...localFilterOptions
                }
                return queryData
            },
            async getPolicies () {
                try {
                    this.getPoliciesLoading = true
                    const policyData = await this.fetchPolicies(this.policiesParams())
                    this.metaData = policyData.data.metadata
                    this.policyItems = policyData.data.items || []
                    this.getPoliciesLoading = false
                    this.initialLoading = false
                } catch (e) {
                    this.getPoliciesLoading = false
                    this.initialLoading = false
                    this.snackbarColor = 'error'
                    this.snackbarText = 'Loading failed'
                    this.snackbar = true
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .history-table::v-deep {
        > .v-data-table__wrapper > table {
            background: #f5f5f5;

            > thead {
                > tr {
                    > th {
                        background: #f5f5f5;
                    }
                }
            }

            > tbody {
                > tr {
                    > td {
                        background: #f5f5f5;
                    }
                }
            }
        }
    }
</style>
